module.exports = __webpack_public_path__ + "img/CAT.fe461a1b.png";